import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import useTotalMessagesCount from "../../libs/fetchTotalMessage";
import useTodayMessagesCount from "../../libs/fetchTodayMessage";
import useOpenMessagesCount from "../../libs/fetchOpenMessage";
import useClosedMessagesCount from "../../libs/fetchClosedMessage";
import useRecentMessagesCount from "../../libs/fetchRecentMessage";
import useConcernStats from "../lib/concernMetric";
import "./OverView.css";

const OverView = () => {
  const {
    totalMessageCount,
    loading: totalLoading,
    error: totalError,
  } = useTotalMessagesCount();

  const {
    todayMessageCount,
    loading: todayLoading,
    error: todayError,
  } = useTodayMessagesCount();

  const {
    openMessageCount,
    loading: openLoading,
    error: openError,
  } = useOpenMessagesCount();

  const {
    closedMessageCount,
    loading: closedLoading,
    error: closedError,
  } = useClosedMessagesCount();

  const {
    recentMessage,
    loading: recentLoading,
    error: recentError,
  } = useRecentMessagesCount();

  const {
    concernStats,
    loading: concernLoading,
    error: concernError,
  } = useConcernStats();

  if (
    totalError ||
    todayError ||
    openError ||
    closedError ||
    recentError ||
    concernError
  ) {
    return (
      <p>
        Error:{" "}
        {totalError ||
          todayError ||
          openError ||
          closedError ||
          recentError ||
          concernError}
      </p>
    );
  }

  const clampWords = (text, maxWords) => {
    const words = text.split(" ");
    const clampedWords = words.slice(0, maxWords);
    return clampedWords.join(" ");
  };

  return (
    <div className="support-overview">
      <div className="header">
        <p>Over View</p>
      </div>

      <div className="wrapper">
        {[
          {
            label: "TOTAL MSG",
            value: totalMessageCount,
            color: "blue",
            loading: totalLoading,
          },
          {
            label: "TOTAL MSG FOR TODAY",
            value: todayMessageCount,
            color: "orange",
            loading: todayLoading,
          },
          {
            label: "TOTAL OPEN MSG",
            value: openMessageCount,
            color: "red",
            loading: openLoading,
          },
          {
            label: "TOTAL CLOSED MSG",
            value: closedMessageCount,
            color: "green",
            loading: closedLoading,
          },
          {
            label: "TOTAL OPEN CONCERNS",
            value: concernStats?.totals?.open ?? 0,
            color: "purple",
            loading: concernLoading,
          },
          {
            label: "TOTAL CLOSED CONCERNS",
            value: concernStats?.totals?.closed ?? 0,
            color: "teal",
            loading: concernLoading,
          },
          {
            label: "TOTAL CONCERNS",
            value: concernStats?.totals?.total ?? 0,
            color: "brown",
            loading: concernLoading,
          },
          {
            label: "LAST CONCERN UPDATE",
            value: new Date(concernStats?.latestUpdate).toLocaleString(
              "en-US",
              {
                timeZone: "Africa/Lagos",
              }
            ),
            color: "gray",
            fontSize: "12px",
            loading: concernLoading,
          },
        ].map((item, idx) => (
          <div className="over-view-box" key={idx}>
            <p>{item.label}</p>
            <h3
              style={{
                color: item.color,
                fontSize: item.fontSize ?? "inherit",
              }}
            >
              {item.loading ? <Skeleton width={60} /> : item.value}
            </h3>
          </div>
        ))}
      </div>

      <div className="recent-message">
        <span>
          <h3>RECENT PUBLIC MESSAGES</h3>
          <Link to="/SupportMessage">View All</Link>
        </span>
        <div className="recent-message-card">
          <table>
            <thead>
              <tr>
                <th>Full Name</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Content</th>
                <th>Created At</th>
                <th>Tickets</th>
              </tr>
            </thead>
            <tbody>
              {recentLoading
                ? Array(4)
                    .fill()
                    .map((_, index) => (
                      <tr key={index}>
                        {Array(6)
                          .fill()
                          .map((__, i) => (
                            <td key={i}>
                              <Skeleton width={100} height={15} />
                            </td>
                          ))}
                      </tr>
                    ))
                : recentMessage.map((message) => (
                    <tr key={message._id} className="message-item">
                      <td>{message.fullname}</td>
                      <td>{message.email}</td>
                      <td>{message.phoneNumber}</td>
                      <td>{clampWords(message.content, 5)}</td>
                      <td>
                        {new Intl.DateTimeFormat("en-US", {
                          timeZone: "Africa/Lagos",
                        }).format(new Date(message.createdAt))}
                      </td>
                      <td>{message.tickets[0]?.ticketCode}</td>
                    </tr>
                  ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OverView;
